import useInterval from 'beautiful-react-hooks/useInterval';
import { SLIDE_NEXT_IN_MILISECONDS } from 'constants/common.const';
import { checkEndOfVideo, resetTimeVideo } from 'helpers/dom-element.helper';
import { isEqualVal } from 'helpers/string.helper';
import { resourceUrl } from 'helpers/url.helper';
import { find, map, orderBy } from 'lodash';
import { MEDIA_TYPES } from 'models/photo/playlist-ads.model';
import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'store/store-hooks';
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react';
import './playlist.css';

const Playlist = () => {
  const { isOpenPlaylist } = useAppSelector((state) => state.selfeApp);
  const { mediaPlaylist } = useAppSelector((state) => state.playlist);
  const [swiper, setSwiper] = useState<SwiperClass | null>(null);
  const [activeSlideIndex, setActiveSlideIndex] = useState(0);
  const [secondCountdown, setSecondCountDown] = useState<number>(
    SLIDE_NEXT_IN_MILISECONDS,
  );
  const [listOfIdAds, setListOfIdAds] = useState<number[]>([]);

  useInterval(() => {
    if (secondCountdown <= 0) {
      setSecondCountDown(SLIDE_NEXT_IN_MILISECONDS);
      swiper && swiper.slideNext();
    } else {
      const adsId = listOfIdAds?.[activeSlideIndex];
      const adsMedia = find(mediaPlaylist?.data, (o) =>
        isEqualVal(o?.id, listOfIdAds?.[activeSlideIndex]),
      );
      const isVideo = isEqualVal(adsMedia?.mediaType, MEDIA_TYPES.VIDEO);
      if (!isVideo) {
        setSecondCountDown((s) => s - 1000);
      } else {
        checkEndOfVideo(`media-preview-video-${adsId}`, () => {
          resetTimeVideo(`media-preview-video-${adsId}`);
          swiper && swiper.slideNext();
        });
      }
    }
  }, 1000);

  useEffect(() => {
    setListOfIdAds(map(mediaPlaylist?.data, (item) => item?.id) || []);
  }, [mediaPlaylist?.data]);

  return (
    <>
      {isOpenPlaylist && (
        <div className="playlist-container">
          <Swiper
            spaceBetween={10}
            onSwiper={setSwiper}
            loop
            onRealIndexChange={(swiperData) => {
              setActiveSlideIndex(swiperData?.realIndex || 0);
            }}
          >
            {map(
              orderBy(mediaPlaylist?.data, [(item) => item?.orderNo], ['asc']),
              (item) => (
                <SwiperSlide key={item?.id} className="playlist-slide">
                  {isEqualVal(MEDIA_TYPES.VIDEO, item?.mediaType) ? (
                    <video
                      id={`media-preview-video-${item?.id}`}
                      src={resourceUrl(item?.mediaUrl)}
                      aria-label="advertisement layout preview"
                      className="resource-item"
                      controls={false}
                      loop={false}
                      muted
                      autoPlay
                    >
                      <track kind="captions" srcLang="en" src="" />
                      <source
                        src={resourceUrl(item?.mediaUrl)}
                        type="video/mp4"
                      />
                    </video>
                  ) : (
                    <img
                      src={resourceUrl(item?.mediaUrl)}
                      alt="advertisement layout preview"
                      className="resource-item"
                    />
                  )}
                </SwiperSlide>
              ),
            )}
          </Swiper>
        </div>
      )}
    </>
  );
};

export default Playlist;
